import apiClient from '../../../shared/config/axios'
import type { DashboardAggregates, DashboardFilters } from '@myapp/contract'

export const dashboardApi = {
  getAggregates: (params: DashboardFilters) =>
    apiClient.get<DashboardAggregates>('/dashboard', { params }),
}
